(function () {
    'use strict';

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initRegisterForm);
    } else {
        initRegisterForm();
    }

    // Hide switch-login-section when redirected from account profile password update button
    function hideSwitchLoginSection() {
        if (new URLSearchParams(window.location.search).get('from') !== 'account-profile') return;
        const switchLoginSection = document.querySelector('#recover .switch-login-section');
        if (switchLoginSection) switchLoginSection.style.display = 'none';
    }

    const initHideSwitch = () => hideSwitchLoginSection();

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initHideSwitch, { once: true });
    } else {
        initHideSwitch();
    }

    window.addEventListener('hashchange', hideSwitchLoginSection, { passive: true });

    function initRegisterForm() {
        const registerForm = document.querySelector('[data-form-type="register"]');
        if (!registerForm) return;

        const passwordToggle = registerForm.querySelector('.password-toggle-register');
        const passwordInput = registerForm.querySelector('#register_password');
        const firstNameInput = registerForm.querySelector('#register_first_name');
        const lastNameInput = registerForm.querySelector('#register_last_name');
        const emailInput = registerForm.querySelector('#register_email');
        const nameErrorRow = registerForm.querySelector('.name-error-row');
        const nameErrorMessages = registerForm.querySelectorAll('.error-message-name');
        const nameRequirementsBox = registerForm.querySelector('#nameRequirements');
        const firstNameErrorIcon = registerForm.querySelector('.form-row .form-field.half:first-child .error-icon-name');
        const lastNameErrorIcon = registerForm.querySelector('.form-row .form-field.half:last-child .error-icon-name');
        const emailErrorIcon = registerForm.querySelector('.error-icon');
        const emailErrorMessage = registerForm.querySelector('.error-message');
        const allInputs = registerForm.querySelectorAll('input[required]');
        const submitBtn = document.getElementById('create-account-btn');
        const privacyAcceptRadio = registerForm.querySelector('#privacy_accept');
        const privacyDeclineRadio = registerForm.querySelector('#privacy_decline');
        const preferredChannelSection = registerForm.querySelector('#preferred-channel-section');
        const channelCheckboxes = registerForm.querySelectorAll('.channel-checkbox');

        // Password toggle
        if (passwordToggle && passwordInput) {
            const newToggle = passwordToggle.cloneNode(true);
            passwordToggle.parentNode.replaceChild(newToggle, passwordToggle);

            const openIcon = newToggle.querySelector('.eye-icon-open');
            const closedIcon = newToggle.querySelector('.eye-icon-closed');

            newToggle.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                if (passwordInput.type === 'password') {
                    passwordInput.type = 'text';
                    if (openIcon) openIcon.style.display = 'none';
                    if (closedIcon) closedIcon.style.display = 'block';
                } else {
                    passwordInput.type = 'password';
                    if (openIcon) openIcon.style.display = 'block';
                    if (closedIcon) closedIcon.style.display = 'none';
                }
            });
        }

        // Name validation
        function validateName(input, errorIcon, errorMessageElement) {
            const nameRegex = /^[A-Za-z\s'\-_.]+$/;
            const isInvalid = input.value && !nameRegex.test(input.value);

            if (isInvalid) {
                input.classList.add('invalid');
                if (errorIcon) errorIcon.style.display = 'block';
                if (errorMessageElement) errorMessageElement.style.display = 'block';
                if (nameRequirementsBox) nameRequirementsBox.style.display = 'block';
                return false;
            } else {
                input.classList.remove('invalid');
                if (errorIcon) errorIcon.style.display = 'none';
                if (errorMessageElement) errorMessageElement.style.display = 'none';

                const firstNameValid = !firstNameInput.classList.contains('invalid');
                const lastNameValid = !lastNameInput.classList.contains('invalid');

                if (firstNameValid && lastNameValid && nameRequirementsBox) {
                    nameRequirementsBox.style.display = 'none';
                }
                return true;
            }
        }

        function updateNameErrorRow() {
            const firstNameInvalid = firstNameInput.classList.contains('invalid');
            const lastNameInvalid = lastNameInput.classList.contains('invalid');

            if (firstNameInvalid || lastNameInvalid) {
                nameErrorRow.style.display = 'flex';
                nameErrorMessages[0].style.display = firstNameInvalid ? 'block' : 'none';
                nameErrorMessages[1].style.display = lastNameInvalid ? 'block' : 'none';
            } else {
                nameErrorRow.style.display = 'none';
            }
        }

        if (firstNameInput) {
            firstNameInput.addEventListener('blur', function () {
                validateName(this, firstNameErrorIcon, nameErrorMessages[0]);
                updateNameErrorRow();
                checkFormValidity();
            });

            firstNameInput.addEventListener('input', function () {
                if (this.classList.contains('invalid')) {
                    validateName(this, firstNameErrorIcon, nameErrorMessages[0]);
                    updateNameErrorRow();
                }
                checkFormValidity();
            });
        }

        if (lastNameInput) {
            lastNameInput.addEventListener('blur', function () {
                validateName(this, lastNameErrorIcon, nameErrorMessages[1]);
                updateNameErrorRow();
                checkFormValidity();
            });

            lastNameInput.addEventListener('input', function () {
                if (this.classList.contains('invalid')) {
                    validateName(this, lastNameErrorIcon, nameErrorMessages[1]);
                    updateNameErrorRow();
                }
                checkFormValidity();
            });
        }

        // Email validation
        function validateEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailInput.value && !emailRegex.test(emailInput.value)) {
                emailInput.classList.add('invalid');
                if (emailErrorIcon) emailErrorIcon.style.display = 'block';
                if (emailErrorMessage) emailErrorMessage.style.display = 'block';
                return false;
            } else {
                emailInput.classList.remove('invalid');
                if (emailErrorIcon) emailErrorIcon.style.display = 'none';
                if (emailErrorMessage) emailErrorMessage.style.display = 'none';
                return true;
            }
        }

        if (emailInput) {
            emailInput.addEventListener('blur', function () {
                validateEmail();
                checkFormValidity();
            });

            emailInput.addEventListener('input', function () {
                if (this.classList.contains('invalid')) {
                    validateEmail();
                }
                checkFormValidity();
            });
        }

        // Phone number validation - must start with 50, 51, 52, 54, 55, 56, or 58, followed by 7 digits (9 total)
        const phoneInput = registerForm.querySelector('#register_phone');
        const phoneErrorIcon = registerForm.querySelector('.phone-field .error-icon');
        const phoneErrorMessage = registerForm.querySelector('.phone-field .error-message');
        const phoneExample = registerForm.querySelector('.phone-field .phone-example');

        function validatePhone() {
            if (!phoneInput) return false;

            const phoneValue = phoneInput.value.trim();

            // Only check if there is text in the phone input
            if (!phoneValue) {
                return true; // Don't validate empty fields
            }

            // Remove any non-numeric characters
            const numericOnly = phoneValue.replace(/[^0-9]/g, '');

            // Check exact length (9 digits)
            if (numericOnly.length !== 9) {
                phoneInput.classList.add('invalid');
                if (phoneErrorIcon) phoneErrorIcon.style.display = 'block';
                if (phoneErrorMessage) phoneErrorMessage.style.display = 'block';
                if (phoneExample) phoneExample.style.display = 'none';
                return false;
            }

            // Check pattern: must start with 50, 51, 52, 54, 55, 56, or 58, followed by 7 digits
            const phonePattern = /^(?:50|51|52||53|54|55|56|58|59)\d{7}$/;
            if (!phonePattern.test(numericOnly)) {
                phoneInput.classList.add('invalid');
                if (phoneErrorIcon) phoneErrorIcon.style.display = 'block';
                if (phoneErrorMessage) phoneErrorMessage.style.display = 'block';
                if (phoneExample) phoneExample.style.display = 'none';
                return false;
            } else {
                phoneInput.classList.remove('invalid');
                if (phoneErrorIcon) phoneErrorIcon.style.display = 'none';
                if (phoneErrorMessage) phoneErrorMessage.style.display = 'none';
                if (phoneExample) phoneExample.style.display = 'block';
                return true;
            }
        }

        if (phoneInput) {
            phoneInput.addEventListener('blur', function () {
                validatePhone();
                checkFormValidity();
            });

            phoneInput.addEventListener('input', function () {
                // Remove any non-numeric characters and limit to 9 digits
                let numericValue = this.value.replace(/[^0-9]/g, '');
                if (numericValue.length > 9) {
                    numericValue = numericValue.substring(0, 9);
                }
                this.value = numericValue;
                updateCustomerTags();
                checkFormValidity();
            });

            // If error state exists, check on keyup until success state
            phoneInput.addEventListener('keyup', function () {
                if (this.classList.contains('invalid')) {
                    validatePhone();
                    checkFormValidity();
                }
            });

            phoneInput.addEventListener('keypress', function (e) {
                // Prevent typing if field already has 9 digits
                const numericValue = this.value.replace(/[^0-9]/g, '');
                if (numericValue.length >= 9 && /[0-9]/.test(String.fromCharCode(e.which))) {
                    e.preventDefault();
                    return;
                }
                
                // Only allow numeric keys (0-9) and control keys (backspace, delete, tab, etc.)
                const char = String.fromCharCode(e.which);
                if (!/[0-9]/.test(char) && !e.ctrlKey && !e.metaKey && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                    e.preventDefault();
                }
            });

            phoneInput.addEventListener('paste', function (e) {
                e.preventDefault();
                const pastedText = (e.clipboardData || window.clipboardData).getData('text');
                const numericValue = pastedText.replace(/[^0-9]/g, '').substring(0, 9);
                this.value = numericValue;
                updateCustomerTags();
                checkFormValidity();
                validatePhone();
            });
        }

        // Password validation
        if (passwordInput) {
            passwordInput.addEventListener('input', function () {
                const value = this.value;
                const requirements = {
                    length: value.length >= 8,
                    uppercase: /[A-Z]/.test(value),
                    lowercase: /[a-z]/.test(value),
                    number: /[0-9]/.test(value)
                };

                Object.keys(requirements).forEach(function (rule) {
                    const element = registerForm.querySelector('[data-rule="' + rule + '"]');
                    if (element) {
                        const checkbox = element.querySelector('.checkbox');
                        const grayIcon = checkbox ? checkbox.querySelector('.icon-gray') : null;
                        const greenIcon = checkbox ? checkbox.querySelector('.icon-green') : null;

                        if (requirements[rule]) {
                            element.classList.add('met');
                            if (grayIcon) grayIcon.style.display = 'none';
                            if (greenIcon) greenIcon.style.display = 'block';
                        } else {
                            element.classList.remove('met');
                            if (grayIcon) grayIcon.style.display = 'block';
                            if (greenIcon) greenIcon.style.display = 'none';
                        }
                    }
                });

                checkFormValidity();
            });
        }

        // Birthday and phone tags - combine into single field
        const birthdayDay = registerForm.querySelector('#register_birthday_day');
        const birthdayMonth = registerForm.querySelector('#register_birthday_month');
        const customerTagsField = registerForm.querySelector('#register_customer_tags');

        // Check if a year is a leap year
        function isLeapYear(year) {
            return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
        }

        // Get number of days in a month (considering leap years for February)
        function getDaysInMonth(month, year) {
            const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            let days = daysInMonth[month - 1] || 31;
            
            if (month === 2 && year && isLeapYear(year)) {
                days = 29;
            }
            
            return days;
        }

        // Update day dropdown based on selected month
        function updateDayDropdown() {
            if (!birthdayDay || !birthdayMonth) return;

            const selectedMonth = parseInt(birthdayMonth.value);
            const currentDay = parseInt(birthdayDay.value);

            if (!selectedMonth) {
                const daysInMonth = 31;
                updateDayOptions(daysInMonth, currentDay);
                return;
            }

            // For February, allow 29 days since users may have been born in a leap year
            const daysInMonth = selectedMonth === 2 ? 29 : getDaysInMonth(selectedMonth, null);
            
            updateDayOptions(daysInMonth, currentDay);
        }

        // Update day select options
        function updateDayOptions(maxDays, currentDay) {
            if (!birthdayDay) return;

            const wasSelected = currentDay && currentDay <= maxDays;

            const selectElement = birthdayDay;
            const firstOption = selectElement.querySelector('option[value=""]');
            selectElement.innerHTML = '';
            
            // Add back the "Select..." option
            if (firstOption) {
                selectElement.appendChild(firstOption.cloneNode(true));
            } else {
                const defaultOption = document.createElement('option');
                defaultOption.value = '';
                defaultOption.textContent = 'Select...';
                selectElement.appendChild(defaultOption);
            }

            // Add day options
            for (let i = 1; i <= maxDays; i++) {
                const option = document.createElement('option');
                option.value = i;
                option.textContent = i;
                if (wasSelected && i === currentDay) {
                    option.selected = true;
                }
                selectElement.appendChild(option);
            }

            // If current day was invalid, clear selection
            if (currentDay && !wasSelected) {
                selectElement.value = '';
            }
        }

        function updateCustomerTags() {
            if (!customerTagsField) return;

            const tags = [];

            // Get birthday tag
            const day = birthdayDay ? birthdayDay.value : '';
            const month = birthdayMonth ? birthdayMonth.value : '';

            if (day && month) {
                // Format: birthday_DD-MM (using underscore for tag compatibility)
                const formattedMonth = month.padStart(2, '0');
                const formattedDay = day.padStart(2, '0');
                tags.push('birthday_' + formattedDay + '-' + formattedMonth);
            }

            // Get phone tag
            const phoneValue = phoneInput ? phoneInput.value.trim() : '';
            if (phoneValue) {
                tags.push('phone_' + phoneValue);
            }

            // Get consent tags
            if (privacyDeclineRadio && privacyDeclineRadio.checked) {
                // User selected "I Do Not Accept"
                tags.push('Onetrust_all_not_accepted');
                // Add persistent tag with "acc-" prefix
                tags.push('acc-Onetrust_all_not_accepted');
            } else if (privacyAcceptRadio && privacyAcceptRadio.checked) {
                // User selected "I Accept" - check which channels are selected
                const selectedChannels = [];
                
                if (channelCheckboxes && channelCheckboxes.length > 0) {
                    channelCheckboxes.forEach(function(checkbox) {
                        if (checkbox.checked) {
                            selectedChannels.push(checkbox.value);
                        }
                    });
                }

                // If all 4 channels are selected, add single tag
                if (selectedChannels.length === 4) {
                    tags.push('Onetrust_all_accepted');
                    // Add persistent tag with "acc-" prefix
                    tags.push('acc-Onetrust_all_accepted');
                } else {
                    // Add individual tags for each selected channel
                    selectedChannels.forEach(function(channel) {
                        const tagName = 'Onetrust_' + channel + '_accepted';
                        tags.push(tagName);
                        // Add persistent tag with "acc-" prefix
                        tags.push('acc-' + tagName);
                    });
                }
            }

            // Combine tags with comma (Shopify accepts comma-separated tags)
            customerTagsField.value = tags.join(',');
        }

        // Birthday validation
        function validateBirthday() {
            if (!birthdayDay || !birthdayMonth) return true;

            const day = birthdayDay.value.trim();
            const month = birthdayMonth.value.trim();

            // If both are empty, it's valid (optional field)
            if (!day && !month) {
                birthdayDay.classList.remove('invalid');
                birthdayMonth.classList.remove('invalid');
                return true;
            }

            // If one is filled but the other is not, it's invalid
            if ((day && !month) || (!day && month)) {
                if (day && !month) {
                    birthdayDay.classList.remove('invalid');
                    birthdayMonth.classList.add('invalid');
                } else {
                    birthdayDay.classList.add('invalid');
                    birthdayMonth.classList.remove('invalid');
                }
                return false;
            }

            // Both are filled, it's valid
            birthdayDay.classList.remove('invalid');
            birthdayMonth.classList.remove('invalid');
            return true;
        }

        if (birthdayDay) {
            birthdayDay.addEventListener('change', function() {
                updateCustomerTags();
                validateBirthday();
                checkFormValidity();
            });
        }
        if (birthdayMonth) {
            birthdayMonth.addEventListener('change', function() {
                updateDayDropdown();
                updateCustomerTags();
                validateBirthday();
                checkFormValidity();
            });
        }

        // Privacy consent validation and channel selection
        function validatePrivacyConsent() {
            if (!privacyAcceptRadio || !privacyDeclineRadio) return false;
            
            // Check if either radio button is selected
            const isAcceptSelected = privacyAcceptRadio.checked;
            const isDeclineSelected = privacyDeclineRadio.checked;
            
            // If neither is selected, invalid
            if (!isAcceptSelected && !isDeclineSelected) {
                return false;
            }
            
            // If "I Do Not Accept" is selected, consent is valid (user declined)
            if (isDeclineSelected) {
                return true;
            }
            
            // If "I Accept" is selected, check if at least one channel is selected
            if (isAcceptSelected) {
                return validateChannelSelection();
            }
            
            return false;
        }

        function validateChannelSelection() {
            if (!channelCheckboxes || channelCheckboxes.length === 0) return false;
            
            let atLeastOneSelected = false;
            channelCheckboxes.forEach(function(checkbox) {
                if (checkbox.checked) {
                    atLeastOneSelected = true;
                }
            });
            
            return atLeastOneSelected;
        }

        function toggleChannelSection() {
            if (!preferredChannelSection) return;
            
            // Show channel section only when "I Accept" is selected
            if (privacyAcceptRadio && privacyAcceptRadio.checked) {
                preferredChannelSection.style.display = 'block';
            } else {
                // Hide channel section when "I Do Not Accept" is selected or neither is selected
                preferredChannelSection.style.display = 'none';
                // Note: We don't uncheck the checkboxes here to preserve their state
                // They will be validated only when the section is visible
            }
        }

        if (privacyAcceptRadio) {
            privacyAcceptRadio.addEventListener('change', function() {
                toggleChannelSection();
                updateCustomerTags();
                checkFormValidity();
            });
        }
        if (privacyDeclineRadio) {
            privacyDeclineRadio.addEventListener('change', function() {
                toggleChannelSection();
                updateCustomerTags();
                checkFormValidity();
            });
        }

        // Add event listeners to channel checkboxes
        if (channelCheckboxes && channelCheckboxes.length > 0) {
            channelCheckboxes.forEach(function(checkbox) {
                checkbox.addEventListener('change', function() {
                    updateCustomerTags();
                    checkFormValidity();
                });
            });
        }

        // Form validation
        allInputs.forEach(function (input) {
            input.addEventListener('input', checkFormValidity);
        });

        function checkFormValidity() {
            if (!submitBtn) return;

            let allFilled = true;
            allInputs.forEach(function (input) {
                if (!input.value.trim()) {
                    allFilled = false;
                }
            });

            const firstNameValid = firstNameInput.value ? !firstNameInput.classList.contains('invalid') : true;
            const lastNameValid = lastNameInput.value ? !lastNameInput.classList.contains('invalid') : true;
            const emailValid = emailInput.value ? !emailInput.classList.contains('invalid') : true;
            const phoneValid = phoneInput ? !phoneInput.classList.contains('invalid') : true;
            const password = passwordInput.value;
            const passwordValid = password.length >= 8 &&
                /[A-Z]/.test(password) &&
                /[a-z]/.test(password) &&
                /[0-9]/.test(password);
            const birthdayValid = validateBirthday();
            const privacyConsentValid = validatePrivacyConsent();

            submitBtn.disabled = !(allFilled && firstNameValid && lastNameValid && emailValid && phoneValid && passwordValid && birthdayValid && privacyConsentValid);
        }

        // Update tags before form submission and validate privacy consent
        if (registerForm) {
            registerForm.addEventListener('submit', function (e) {
                updateCustomerTags();
            });
        }

        // Initialize channel section visibility
        toggleChannelSection();

        checkFormValidity();
    }
})();